export const SET_DISPLAY_LEFT_DRAWER = 'SET_DISPLAY_LEFT_DRAWER';

export function setDisplayLeftDrawer(display) {
    return {
        type: SET_DISPLAY_LEFT_DRAWER,
        payload: display
    };
}

